export const enum BlockPosition {
  WRAPPER_CHILD_BEFORE = 'wrapper-child-before',
  WRAPPER_CHILD_AFTER = 'wrapper-child-after',
  BEFORE_TITLE = 'before-title',
  BEFORE_PARAGRAPH = 'before-paragraph',
  BEFORE_BUTTON = 'before-button',
  BEFORE_NOTE = 'before-note',
  AFTER_NOTE = 'after-note',
}
